/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { Assets } from './Assets';
import {
    AssetsFromJSON,
    AssetsFromJSONTyped,
    AssetsToJSON,
} from './Assets';
import type { ControlAbridgedCyberBenchmark } from './ControlAbridgedCyberBenchmark';
import {
    ControlAbridgedCyberBenchmarkFromJSON,
    ControlAbridgedCyberBenchmarkFromJSONTyped,
    ControlAbridgedCyberBenchmarkToJSON,
} from './ControlAbridgedCyberBenchmark';
import type { ControlAppSchemasExternalAsmEntityResponsesEntityVulnerabilitiesCount } from './ControlAppSchemasExternalAsmEntityResponsesEntityVulnerabilitiesCount';
import {
    ControlAppSchemasExternalAsmEntityResponsesEntityVulnerabilitiesCountFromJSON,
    ControlAppSchemasExternalAsmEntityResponsesEntityVulnerabilitiesCountFromJSONTyped,
    ControlAppSchemasExternalAsmEntityResponsesEntityVulnerabilitiesCountToJSON,
} from './ControlAppSchemasExternalAsmEntityResponsesEntityVulnerabilitiesCount';
import type { ControlEntityMetrics } from './ControlEntityMetrics';
import {
    ControlEntityMetricsFromJSON,
    ControlEntityMetricsFromJSONTyped,
    ControlEntityMetricsToJSON,
} from './ControlEntityMetrics';
import type { ControlEntityRelation } from './ControlEntityRelation';
import {
    ControlEntityRelationFromJSON,
    ControlEntityRelationFromJSONTyped,
    ControlEntityRelationToJSON,
} from './ControlEntityRelation';
import type { ControlEntityRiskScoreV2 } from './ControlEntityRiskScoreV2';
import {
    ControlEntityRiskScoreV2FromJSON,
    ControlEntityRiskScoreV2FromJSONTyped,
    ControlEntityRiskScoreV2ToJSON,
} from './ControlEntityRiskScoreV2';
import type { ControlPolicy } from './ControlPolicy';
import {
    ControlPolicyFromJSON,
    ControlPolicyFromJSONTyped,
    ControlPolicyToJSON,
} from './ControlPolicy';
import type { ControlPolicyMetrics } from './ControlPolicyMetrics';
import {
    ControlPolicyMetricsFromJSON,
    ControlPolicyMetricsFromJSONTyped,
    ControlPolicyMetricsToJSON,
} from './ControlPolicyMetrics';
import type { Dataleaks } from './Dataleaks';
import {
    DataleaksFromJSON,
    DataleaksFromJSONTyped,
    DataleaksToJSON,
} from './Dataleaks';

/**
 * 
 * @export
 * @interface ControlEntityRelationResponseV1
 */
export interface ControlEntityRelationResponseV1 {
    /**
     * 
     * @type {string}
     * @memberof ControlEntityRelationResponseV1
     */
    entity_id?: string;
    /**
     * 
     * @type {string}
     * @memberof ControlEntityRelationResponseV1
     */
    entity_name?: string;
    /**
     * 
     * @type {string}
     * @memberof ControlEntityRelationResponseV1
     */
    entity_domain?: string;
    /**
     * 
     * @type {string}
     * @memberof ControlEntityRelationResponseV1
     */
    entity_logo_url?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof ControlEntityRelationResponseV1
     */
    domains?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof ControlEntityRelationResponseV1
     */
    ip_addresses?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof ControlEntityRelationResponseV1
     */
    monit_type?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof ControlEntityRelationResponseV1
     */
    data_sources?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof ControlEntityRelationResponseV1
     */
    keywords?: Array<string>;
    /**
     * 
     * @type {ControlEntityMetrics}
     * @memberof ControlEntityRelationResponseV1
     */
    metrics?: ControlEntityMetrics;
    /**
     * 
     * @type {Assets}
     * @memberof ControlEntityRelationResponseV1
     */
    assets?: Assets;
    /**
     * 
     * @type {ControlAppSchemasExternalAsmEntityResponsesEntityVulnerabilitiesCount}
     * @memberof ControlEntityRelationResponseV1
     */
    vulnerabilities?: ControlAppSchemasExternalAsmEntityResponsesEntityVulnerabilitiesCount;
    /**
     * 
     * @type {Dataleaks}
     * @memberof ControlEntityRelationResponseV1
     */
    dataleaks?: Dataleaks;
    /**
     * 
     * @type {number}
     * @memberof ControlEntityRelationResponseV1
     */
    lookalikes?: number;
    /**
     * 
     * @type {number}
     * @memberof ControlEntityRelationResponseV1
     */
    honeypots?: number;
    /**
     * 
     * @type {number}
     * @memberof ControlEntityRelationResponseV1
     */
    torrents?: number;
    /**
     * 
     * @type {number}
     * @memberof ControlEntityRelationResponseV1
     */
    risk_score?: number;
    /**
     * 
     * @type {ControlEntityRiskScoreV2}
     * @memberof ControlEntityRelationResponseV1
     */
    risk_score_v2?: ControlEntityRiskScoreV2;
    /**
     * 
     * @type {ControlEntityRiskScoreV2}
     * @memberof ControlEntityRelationResponseV1
     */
    previous_risk_score_v2?: ControlEntityRiskScoreV2;
    /**
     * 
     * @type {string}
     * @memberof ControlEntityRelationResponseV1
     */
    report_url?: string;
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof ControlEntityRelationResponseV1
     */
    localized_reports?: { [key: string]: string; };
    /**
     * 
     * @type {string}
     * @memberof ControlEntityRelationResponseV1
     */
    status?: string;
    /**
     * 
     * @type {string}
     * @memberof ControlEntityRelationResponseV1
     */
    created?: string;
    /**
     * 
     * @type {string}
     * @memberof ControlEntityRelationResponseV1
     */
    updated?: string;
    /**
     * 
     * @type {string}
     * @memberof ControlEntityRelationResponseV1
     */
    scanned?: string;
    /**
     * 
     * @type {ControlAbridgedCyberBenchmark}
     * @memberof ControlEntityRelationResponseV1
     */
    cyber_benchmark?: ControlAbridgedCyberBenchmark;
    /**
     * 
     * @type {string}
     * @memberof ControlEntityRelationResponseV1
     */
    external_id?: string;
    /**
     * 
     * @type {ControlPolicy}
     * @memberof ControlEntityRelationResponseV1
     */
    policy?: ControlPolicy;
    /**
     * 
     * @type {ControlEntityRelation}
     * @memberof ControlEntityRelationResponseV1
     */
    relation?: ControlEntityRelation;
    /**
     * 
     * @type {ControlPolicyMetrics}
     * @memberof ControlEntityRelationResponseV1
     */
    policy_metrics?: ControlPolicyMetrics;
    /**
     * 
     * @type {boolean}
     * @memberof ControlEntityRelationResponseV1
     */
    is_main_entity?: boolean;
    /**
     * 
     * @type {number}
     * @memberof ControlEntityRelationResponseV1
     */
    days_until_deletable?: number;
}

/**
 * Check if a given object implements the ControlEntityRelationResponseV1 interface.
 */
export function instanceOfControlEntityRelationResponseV1(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function ControlEntityRelationResponseV1FromJSON(json: any): ControlEntityRelationResponseV1 {
    return ControlEntityRelationResponseV1FromJSONTyped(json, false);
}

export function ControlEntityRelationResponseV1FromJSONTyped(json: any, ignoreDiscriminator: boolean): ControlEntityRelationResponseV1 {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'entity_id': !exists(json, 'entity_id') ? undefined : json['entity_id'],
        'entity_name': !exists(json, 'entity_name') ? undefined : json['entity_name'],
        'entity_domain': !exists(json, 'entity_domain') ? undefined : json['entity_domain'],
        'entity_logo_url': !exists(json, 'entity_logo_url') ? undefined : json['entity_logo_url'],
        'domains': !exists(json, 'domains') ? undefined : json['domains'],
        'ip_addresses': !exists(json, 'ip_addresses') ? undefined : json['ip_addresses'],
        'monit_type': !exists(json, 'monit_type') ? undefined : json['monit_type'],
        'data_sources': !exists(json, 'data_sources') ? undefined : json['data_sources'],
        'keywords': !exists(json, 'keywords') ? undefined : json['keywords'],
        'metrics': !exists(json, 'metrics') ? undefined : ControlEntityMetricsFromJSON(json['metrics']),
        'assets': !exists(json, 'assets') ? undefined : AssetsFromJSON(json['assets']),
        'vulnerabilities': !exists(json, 'vulnerabilities') ? undefined : ControlAppSchemasExternalAsmEntityResponsesEntityVulnerabilitiesCountFromJSON(json['vulnerabilities']),
        'dataleaks': !exists(json, 'dataleaks') ? undefined : DataleaksFromJSON(json['dataleaks']),
        'lookalikes': !exists(json, 'lookalikes') ? undefined : json['lookalikes'],
        'honeypots': !exists(json, 'honeypots') ? undefined : json['honeypots'],
        'torrents': !exists(json, 'torrents') ? undefined : json['torrents'],
        'risk_score': !exists(json, 'risk_score') ? undefined : json['risk_score'],
        'risk_score_v2': !exists(json, 'risk_score_v2') ? undefined : ControlEntityRiskScoreV2FromJSON(json['risk_score_v2']),
        'previous_risk_score_v2': !exists(json, 'previous_risk_score_v2') ? undefined : ControlEntityRiskScoreV2FromJSON(json['previous_risk_score_v2']),
        'report_url': !exists(json, 'report_url') ? undefined : json['report_url'],
        'localized_reports': !exists(json, 'localized_reports') ? undefined : json['localized_reports'],
        'status': !exists(json, 'status') ? undefined : json['status'],
        'created': !exists(json, 'created') ? undefined : json['created'],
        'updated': !exists(json, 'updated') ? undefined : json['updated'],
        'scanned': !exists(json, 'scanned') ? undefined : json['scanned'],
        'cyber_benchmark': !exists(json, 'cyber_benchmark') ? undefined : ControlAbridgedCyberBenchmarkFromJSON(json['cyber_benchmark']),
        'external_id': !exists(json, 'external_id') ? undefined : json['external_id'],
        'policy': !exists(json, 'policy') ? undefined : ControlPolicyFromJSON(json['policy']),
        'relation': !exists(json, 'relation') ? undefined : ControlEntityRelationFromJSON(json['relation']),
        'policy_metrics': !exists(json, 'policy_metrics') ? undefined : ControlPolicyMetricsFromJSON(json['policy_metrics']),
        'is_main_entity': !exists(json, 'is_main_entity') ? undefined : json['is_main_entity'],
        'days_until_deletable': !exists(json, 'days_until_deletable') ? undefined : json['days_until_deletable'],
    };
}

export function ControlEntityRelationResponseV1ToJSON(value?: ControlEntityRelationResponseV1 | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'entity_id': value.entity_id,
        'entity_name': value.entity_name,
        'entity_domain': value.entity_domain,
        'entity_logo_url': value.entity_logo_url,
        'domains': value.domains,
        'ip_addresses': value.ip_addresses,
        'monit_type': value.monit_type,
        'data_sources': value.data_sources,
        'keywords': value.keywords,
        'metrics': ControlEntityMetricsToJSON(value.metrics),
        'assets': AssetsToJSON(value.assets),
        'vulnerabilities': ControlAppSchemasExternalAsmEntityResponsesEntityVulnerabilitiesCountToJSON(value.vulnerabilities),
        'dataleaks': DataleaksToJSON(value.dataleaks),
        'lookalikes': value.lookalikes,
        'honeypots': value.honeypots,
        'torrents': value.torrents,
        'risk_score': value.risk_score,
        'risk_score_v2': ControlEntityRiskScoreV2ToJSON(value.risk_score_v2),
        'previous_risk_score_v2': ControlEntityRiskScoreV2ToJSON(value.previous_risk_score_v2),
        'report_url': value.report_url,
        'localized_reports': value.localized_reports,
        'status': value.status,
        'created': value.created,
        'updated': value.updated,
        'scanned': value.scanned,
        'cyber_benchmark': ControlAbridgedCyberBenchmarkToJSON(value.cyber_benchmark),
        'external_id': value.external_id,
        'policy': ControlPolicyToJSON(value.policy),
        'relation': ControlEntityRelationToJSON(value.relation),
        'policy_metrics': ControlPolicyMetricsToJSON(value.policy_metrics),
        'is_main_entity': value.is_main_entity,
        'days_until_deletable': value.days_until_deletable,
    };
}

